export const SeafoodCategory1Id = '7d3c11b2-e182-4c50-880e-0990c41686ba';
export const SeafoodCategory2Id = '91b00475-b1db-4113-a449-06949eb1e77f';
export const SeafoodCategory3Id = '74d12412-8d6b-4b02-8c44-744239b66df1';

export const SeafoodCategory1Urls = [
    'https://norwayseafoodfestival.no/event/san-sebastian-tapas/',
    'https://norwayseafoodfestival.no/event/sot-sabrura-torvet/',
    'https://norwayseafoodfestival.no/event/sabrura-solsiden/',
    'https://norwayseafoodfestival.no/event/sabrura-bakklandet/',
    'https://norwayseafoodfestival.no/event/bakgarden-tapas/',
    'https://norwayseafoodfestival.no/event/brasserie-britannia/',
    'https://norwayseafoodfestival.no/event/to-rom-og-kjokken/',
    'https://norwayseafoodfestival.no/event/grafen-trondheim/',
    'https://norwayseafoodfestival.no/event/sabrura-city-syd/',
    'https://norwayseafoodfestival.no/event/san-sebastian-tapas-2/',
    'https://norwayseafoodfestival.no/event/krambua-15-3-21-3-2024/',
    'https://norwayseafoodfestival.no/event/sabrura-sirkus/',
    'https://norwayseafoodfestival.no/event/sabrura-city-lade/',
    'https://norwayseafoodfestival.no/event/sot-sabrura-torvet-3/',
    'https://norwayseafoodfestival.no/event/sabrura-solsiden-3/',
    'https://norwayseafoodfestival.no/event/sabrura-bakklandet-3/',
    'https://norwayseafoodfestival.no/event/bakgarden-tapas-3/',
    'https://norwayseafoodfestival.no/event/the-crab-og-norway-seafood-festival/',
    'https://norwayseafoodfestival.no/event/akt-bar-og-smugspiseri/',
    'https://norwayseafoodfestival.no/event/brasserie-britannia-3/',
    'https://norwayseafoodfestival.no/event/to-rom-og-kjokken-3/',
    'https://norwayseafoodfestival.no/event/grafen-trondheim-3/',
    'https://norwayseafoodfestival.no/event/spontan-x-sjomat-festival/',
    'https://norwayseafoodfestival.no/event/fagn-bistro-mandag/',
    'https://norwayseafoodfestival.no/event/visit-bjorn-bacalao-party/',
    'https://norwayseafoodfestival.no/event/sabrura-city-syd-3/',
    'https://norwayseafoodfestival.no/event/krambua-15-3-21-3-2024-3/',
    'https://norwayseafoodfestival.no/event/sabrura-sirkus-3/',
    'https://norwayseafoodfestival.no/event/san-sebastian-tapas-3/',
    'https://norwayseafoodfestival.no/event/sabrura-city-lade-3/',
    'https://norwayseafoodfestival.no/event/sot-sabrura-torvet-5/',
    'https://norwayseafoodfestival.no/event/sabrura-solsiden-5/',
    'https://norwayseafoodfestival.no/event/sabrura-bakklandet-5/',
    'https://norwayseafoodfestival.no/event/bakgarden-tapas-5/',
    'https://norwayseafoodfestival.no/event/grafen-trondheim-5/',
    'https://norwayseafoodfestival.no/event/akt-bar-og-smugspiseri-3/',
    'https://norwayseafoodfestival.no/event/the-crab-og-norway-seafood-festival-3/',
    'https://norwayseafoodfestival.no/event/brasserie-britannia-5/',
    'https://norwayseafoodfestival.no/event/to-rom-og-kjokken-5/',
    'https://norwayseafoodfestival.no/event/e-c-dahls-pub-og-kjokken/',
    'https://norwayseafoodfestival.no/event/spontan-x-sjomat-festival-3/',
    'https://norwayseafoodfestival.no/event/fagn-bistro/',
    'https://norwayseafoodfestival.no/event/sabrura-city-syd-5/',
    'https://norwayseafoodfestival.no/event/san-sebastian-tapas-4/',
    'https://norwayseafoodfestival.no/event/sot-sabrura-torvet-7/',
    'https://norwayseafoodfestival.no/event/sabrura-city-lade-5/',
    'https://norwayseafoodfestival.no/event/sabrura-sirkus-5/',
    'https://norwayseafoodfestival.no/event/krambua-15-3-21-3-2024-5/',
    'https://norwayseafoodfestival.no/event/sabrura-solsiden-7/',
    'https://norwayseafoodfestival.no/event/sabrura-bakklandet-7/',
    'https://norwayseafoodfestival.no/event/bakgarden-tapas-7/',
    'https://norwayseafoodfestival.no/event/akt-bar-og-smugspiseri-5/',
    'https://norwayseafoodfestival.no/event/the-crab-og-norway-seafood-festival-5/',
    'https://norwayseafoodfestival.no/event/grafen-trondheim-7/',
    'https://norwayseafoodfestival.no/event/brasserie-britannia-7/',
    'https://norwayseafoodfestival.no/event/to-rom-og-kjokken-7/',
    'https://norwayseafoodfestival.no/event/fagn-bistro-3/',
    'https://norwayseafoodfestival.no/event/spontan-x-sjomat-festival-5/',
    'https://norwayseafoodfestival.no/event/e-c-dahls-pub-og-kjokken-3/',
    'https://norwayseafoodfestival.no/event/sabrura-city-syd-7/',
    'https://norwayseafoodfestival.no/event/krambua-15-3-21-3-2024-7/',
    'https://norwayseafoodfestival.no/event/sabrura-sirkus-7/',
    'https://norwayseafoodfestival.no/event/sabrura-city-lade-7/',
    'https://norwayseafoodfestival.no/event/san-sebastian-tapas-5/',
    'https://norwayseafoodfestival.no/event/sot-sabrura-torvet-9/',
    'https://norwayseafoodfestival.no/event/sabrura-solsiden-9/',
    'https://norwayseafoodfestival.no/event/sabrura-bakklandet-9/',
    'https://norwayseafoodfestival.no/event/bakgarden-tapas-9/',
    'https://norwayseafoodfestival.no/event/brasserie-britannia-9/',
    'https://norwayseafoodfestival.no/event/the-crab-og-norway-seafood-festival-7/',
    'https://norwayseafoodfestival.no/event/akt-bar-og-smugspiseri-7/',
    'https://norwayseafoodfestival.no/event/to-rom-og-kjokken-9/',
    'https://norwayseafoodfestival.no/event/grafen-trondheim-9/',
    'https://norwayseafoodfestival.no/event/spontan-x-sjomat-festival-7/',
    'https://norwayseafoodfestival.no/event/fagn-bistro-5/',
    'https://norwayseafoodfestival.no/event/e-c-dahls-pub-og-kjokken-5/',
    'https://norwayseafoodfestival.no/event/visit-bjorns-bacalao-party/'
];

export const SeafoodCategory2Urls = ['https://norwayseafoodfestival.no/event/sjomatens-fremtid/'];

export const SeafoodCategory3Urls = [];
